<template>
    <div class="col-lg-8">
        <div class="profile-block">

            <h3 class="profile-block-heading">
                {{ lang.profileEdit }}
            </h3>

            <form @submit.prevent="submitUpdatedDetails" id="profile-edit-form-main"
                  class="profile-box profile-edit-form-main" autocomplete="on">
                <div class="row">
                    <div class="col-sm-6 col-md-4 mb-4">
                        <div class="form-group">
                            <label for="edit-email">{{ lang.email }}</label>
                            <input type="email" class="form-control" id="edit-email" name="email" v-model="forms.fields.email" required>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4 mb-4">
                        <div class="form-group">
                            <label for="first-name">{{ lang.firstName }}</label>
                            <input type="text" class="form-control" id="first-name" name="first_name" v-model="forms.fields.first_name" required>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4 mb-4">
                        <div class="form-group">
                            <label for="last-name">{{ lang.lastName }}</label>
                            <input type="text" class="form-control" id="last-name" name="last_name" v-model="forms.fields.last_name" required>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4 mb-4">
                        <div class="form-group">
                            <label for="company-name">{{ lang.companyName }}</label>
                            <input type="text" class="form-control" id="company-name" name="company_name" v-model="forms.fields.company_name" required>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4 mb-4">
                        <div class="form-group">
                            <label for="company-activity">{{ lang.activity }}</label>
                            <input type="text" class="form-control" id="company-activity" name="company_activity" v-model="forms.fields.company_activity" required>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4 mb-4">
                        <div class="form-group">
                            <label for="phone">{{ lang.phone }}</label>
                            <input type="text" class="form-control" id="phone" name="phone" v-model="forms.fields.phone" required>
                        </div>
                    </div>
                </div>

                <button type="submit" class="btn btn-main grey float-right">{{ lang.saveButton }}</button>
            </form>
        </div>

        <div class="profile-block">

            <h3 class="profile-block-heading mt-5">
                {{ lang.passwordEdit }}
            </h3>

            <form @submit.prevent="submitUpdatedPassword" id="profile-edit-form-password"
                  class="profile-box profile-edit-form-password" autocomplete="on">
                <div class="row">
                    <div class="col-sm-4 col-md-4 mb-4">
                        <div class="form-group">
                            <label for="old-password">{{ lang.oldPassword }}</label>
                            <input type="password" class="form-control" id="old-password"
                                   name="old_password"
                                   autocomplete="on"
                                   v-model="forms.passwords.old_password" required>
                        </div>
                    </div>

                    <div class="col-sm-4 col-md-4 mb-4">
                        <div class="form-group">
                            <label for="new-password">{{ lang.newPassword }}</label>
                            <input type="password" class="form-control" id="new-password"
                                   name="new_password"
                                   autocomplete="on"
                                   v-model="forms.passwords.new_password" required>
                        </div>
                    </div>

                    <div class="col-sm-4 col-md-4 mb-4">
                        <div class="form-group">
                            <label for="old-password">{{ lang.confirmPassword }}</label>
                            <input type="password" class="form-control" id="confirm-password"
                                   name="new_password_confirmation"
                                   autocomplete="on"
                                   v-model="forms.passwords.new_password_confirmation" required>
                        </div>
                    </div>
                </div>
                <button type="submit" class="btn btn-main grey float-right">{{ lang.saveButton }}</button>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    require ('../../../plugins-config/plugins-config.js');

    const lang = $('body').data().locale;
    const enPrefix = lang === 'en' ? '/en' : '';

    export default {
        name: "ProfileEdit",
        data: function () {
            return {
                forms: {
                    success: true,
                    fields: {
                        email: this.userData.email,
                        first_name: this.userData.first_name,
                        last_name: this.userData.last_name,
                        company_name: this.userData.company_name,
                        company_activity: this.userData.company_activity,
                        phone: this.userData.phone,
                    },
                    passwords: {
                        old_password: '',
                        new_password_confirmation: '',
                        new_password: '',
                    }
                },
                //*** Translations from lang/bg/js.php ***//
                lang: jsLangs,
            }
        },
        props: {
            userData: '',
        },
        methods: {
            submitUpdatedDetails() {
                axios.post(enPrefix + '/users/profile/update_details', this.forms.fields
                ).then(() => {
                    toastr.success(this.lang.successText, this.lang.successTitle);
                })
                .catch(() => {

                        //console.log("Error: ",error.response.data);

                        toastr.error(this.lang.errorText, this.lang.errorTitle);
                });
            },
            submitUpdatedPassword() {
                axios.post(enPrefix + '/users/profile/change_password', this.forms.passwords,
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                    .then(() => {
                        toastr.success(this.lang.successText, this.lang.successTitle);
                    })
                    .catch((error) => {
                        console.log("Error: ",error.response.data);
                        toastr.error(this.lang.errorText, this.lang.errorTitle);
                    })
                    .then(() => {
                        // always executed
                        if($("#profile-edit-form-password").valid()) {
                            this.forms.passwords = '';
                        }
                });

            }

        },
        mounted() {

            /*** Validate Profile Update Section ***/
            const updateDetailsForm = $('#profile-edit-form-main');
            updateDetailsForm.validate({
                ignore: [],
                rules: {
                    field: {
                        required: true
                    },
                    first_name: {
                        normalizer: function(value) {
                            return $.trim(value);
                        },
                        minlength: 1
                    },
                    last_name: {
                        normalizer: function(value) {
                            return $.trim(value);
                        },
                        minlength: 1
                    },
                    email: {
                        normalizer: function(value) {
                            return $.trim(value);
                        },
                        email: true
                    },
                    phone: {
                        normalizer: function(value) {
                            return $.trim(value);
                        },
                        minlength: 6
                    },
                    company_name: {
                        normalizer: function(value) {
                            return $.trim(value);
                        },
                        minlength: 1
                    },
                    company_activity: {
                        normalizer: function(value) {
                            return $.trim(value);
                        },
                        minlength: 1
                    },
                }
            });

            /*** Validate Change Password Section ***/
            const changePasswordForm = $('#profile-edit-form-password');
            changePasswordForm.validate({
                ignore: [],
                rules: {
                    old_password: {
                        normalizer: function(value) {
                            return $.trim(value);
                        },
                        minlength: 6
                    },
                    new_password: {
                        normalizer: function(value) {
                            return $.trim(value);
                        },
                        minlength: 6
                    },
                    confirm_password: {
                        normalizer: function(value) {
                            return $.trim(value);
                        },
                        minlength: 6,
                        equalTo: "#new-password"
                    },
                }
            });
        }

    }
</script>
